import * as React from "react";
import { forwardRef } from "react";
const SvgBackButton = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "current", id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("path", { d: "M39,19H3.51L20.74,1.77a1.05,1.05,0,0,0,0-1.47,1.05,1.05,0,0,0-1.47,0l-19,19a1,1,0,0,0,0,1.46l19,19a1,1,0,1,0,1.47-1.47L3.51,21H39a1,1,0,0,0,0-2Z" }));
const ForwardRef = forwardRef(SvgBackButton);
export { ForwardRef as ReactComponent };
